<template>
  <div class="invoice">
    <topTitle
      title="发票开票"
      :options="{'bgColor':'linear-gradient(to right, #FF5145, #E52F23, #CD0F02)','navColor':'#fff'}"
    ></topTitle>
    <div>
        <div class="box">
          <div class="item">
            发票类型：
          </div>
          <div class="item">
            <van-radio-group class="type" v-model="fptype" direction="horizontal">
              <van-radio name="ELECTRO">普通发票</van-radio>
              <van-radio name="VATOSPECIAL" :disabled="sfjz">增值税专用发票</van-radio>
            </van-radio-group>
          </div>
          <p v-if="sfjz">本商品不支持开具专用发票</p>
        </div>
        <template v-if="fptype == 'ELECTRO'">
          <van-field  class="mt-20" name="radio" label="发票抬头">
            <template #input>
              <van-radio-group v-model="radio" direction="horizontal">
                <van-radio name="1">个人</van-radio>
                <van-radio name="2">企业</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <div v-if="radio == '2'">
            <van-field v-model="dwmc" name="单位名称" label="单位名称" placeholder="请输入单位名称"/>
            <van-field v-model="nsrsbm" name="纳税人识别码" label="纳税人识别码" placeholder="请输入纳税人识别码"/>
          </div>
          <div v-if="radio == '1'">
            <van-field v-model="dwmc" name="个人名称" label="个人名称" placeholder="请输入个人名称" />
          </div>

        </template>
        <template v-if="fptype == 'VATOSPECIAL'">
          <div class="scjsh" v-if="infoShow">
            <h3>专票发票资质上传及审核结果查询地址：</h3>
            <p>个人中心-账号管理-增票资质-添加或修改</p>
            <div class="img">
              <img src="../../assets/localImage/wt.png" alt="">
            </div>
          </div>
          <div class="mt-20" v-else>
              <div class="pl">
                <van-field v-model="zpInfo.receipt_title" name="单位名称" label="单位名称" placeholder="请输入单位名称" :readonly='issh' />
                <van-field v-model="zpInfo.tax_no" name="纳税人识别码" label="纳税人识别码" placeholder="请输入纳税人识别码" :readonly='issh'/>
              </div>
              <van-field class="mt-20" v-model="zpInfo.register_add" name="注册地址" label="注册地址" placeholder="请输入注册地址" :readonly='issh'/>
              <van-field v-model="zpInfo.member_mobile" name="注册电话" label="注册电话" placeholder="请输入注册电话" :readonly='issh'/>
              <van-field v-model="zpInfo.bank_name" name="开户银行" label="开户银行" placeholder="请输入开户银行" :readonly='issh'/>
              <van-field v-model="zpInfo.bank_account" name="银行帐号" label="银行帐号" placeholder="请输入银行帐号" :readonly='issh'/>
          </div>

        </template>
        
        
    </div>
    
    <div class="fontBtn">
      <button @click="onConfirm()">提交</button>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
// import { Swipe, SwipeItem, Tab, Tabs, Dialog} from 'vant';
export default {
  name: "invoice",
  data() {
    return {
      fptype:"ELECTRO",
      infoShow:true,
      issh:true,
      zpInfo:{
        receipt_title:'',
        tax_no:'',
        register_add:'',
        member_mobile:'',
        bank_name:'',
        bank_account:'',
        receipt_type:''
      },
      sfjz: eval(this.$route.query.tax_receipt_status),
      dwmc:"",
      nsrsbm:"",
      radio: "1",


    };
  },
  components: {
    topTitle
  },
  created(){
    this.getData();
  },
  methods: {
    getData(){
      this.postRequest(`members/receipt/myReceipt`).then(res => {
        if(res.data.code == 0){
          if(res.data.data.state == 1){
            this.zpInfo = res.data.data;
            this.infoShow = false;
          }else if(res.data.data.state == 0){
            this.infoShow = true;
          }
        }else if(res.data.code == 1){
          this.infoShow = true;
        }
      });
    },
    
    onConfirm() {
      let obj = {
        receipt_title: '',
        tax_no: '',
        register_add: '',
        member_mobile: '',
        bank_name: '',
        bank_account: '',
        receipt_type: this.fptype
      }
      if(this.fptype = "ELECTRO"){
        obj.receipt_title = this.dwmc;
        if(this.radio ==  2){
          obj.tax_no = this.nsrsbm;
        }
      }else{
        let obj = {
          receipt_title: this.zpInfo.receipt_title,
          tax_no: this.zpInfo.tax_no,
          register_add: this.zpInfo.register_add,
          member_mobile: this.zpInfo.member_mobile,
          bank_name: this.zpInfo.bank_name,
          bank_account: this.zpInfo.bank_account,
          receipt_type: this.fptype
        }
      }
      
      console.log(obj)
      this.postRequest(`trade/checkout-params/receipt`,obj).then(res => {
        this.$router.push({
          path:'ConfirmationOrder',
          query:{
             fptype:this.radio
          }
          });
      });
    }
  }
};
</script>


<style scoped lang='less'>
.invoice {
  .box{
    background: #ffffff;
    p{
      padding: 12px 56px;
      font-size:24px;
      font-family:PingFangSC-Regular,PingFang SC;  
    }
    .item{
      width: 100%;
      height: 89px;
      line-height: 89px;
      position: relative;
      
      padding-left: 30px;
      font-size:30px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      .type{
        height: 100%;
        padding: 0 30px 15px 0;
        display: flex;
        justify-content: space-around;
      }
    }
    .item::after {
      position: absolute;
      box-sizing: border-box;
      content: ' ';
      pointer-events: none;
      right: 0;
      bottom: 0;
      left: 0.42667rem;
      border-bottom: 0.02667rem solid #ebedf0;
      -webkit-transform: scaleY(.5);
      transform: scaleY(.5);
    }
  }
  .scjsh{
    width: 100%;
    height: 565px;
    background: #ffffff;
    margin-top: 20px;
    padding: 30px;
    font-size:30px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    .img{
      width: 277px;
      height: 277px;
      img{
        width: 100%;
        height: 100%;
      }
      margin: 74px auto;
    }
    h3{
      color: #000000;
      font-size:30px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      margin-bottom: 20px;
    }
    p{
      color: #FF5B10;
    }
  }
  .van-cell{
  font-size:30px !important;
  font-weight:400 !important;
  }
  /deep/.van-field__control:disabled{
    color: #000;
    -webkit-text-fill-color:#000;
  }

  .van-radio-group{
    display: flex;
    /deep/.van-radio{
      margin-right: 80px;
      .van-radio__icon--checked .van-icon{
        background: linear-gradient(to right, #fc4d1d, #cf1104);
        border-color: transparent; 
      }
    }
  }
}
</style>


